import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils";

export const stockList = createAsyncThunk('stock/list', async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `stock_management`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
                'product_id': data?.product_id,
                'category_id': data?.category_id,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const stockConfigurationSearch = createAsyncThunk('stock/configuration', async ({ values, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + 'variant_by_category',
            params: {
                'category_id': values?.category_id,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const saveStockConfiguration = createAsyncThunk('stock/configuration/save', async ({ values }) => {
    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'stock_management',
            data: values,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const stockAvailability = createAsyncThunk('stock/availability', async ({ filters, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + 'stock_availability',
            params: {
                'category_id': filters?.category_id,
                'product_id': filters?.product_id,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const stock = createSlice({
    name: 'stock',
    initialState: {
        list: [],
        configuration: [],
        availability: [],
        loading: false,
    },
    reducers: {
        clearStockConfiguration: (state) => {
            state.configuration = []
        },
        clearStockAvailability: (state) => {
            state.availability = []
        },
    },
    extraReducers: (builder) => {
        builder.addCase(stockList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.list = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.list = []
            }
        });

        builder.addCase(stockConfigurationSearch.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.configuration = action.payload.data.data || [];
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.configuration = []
            }
        });

        builder.addCase(stockAvailability.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.availability = action.payload.data.data || [];
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.availability = []
            }
        });
    }
})

export const { clearStockConfiguration, clearStockAvailability } = stock.actions
export default stock.reducer;